export class ContentModal {
    id:number = 0;
    img:string = '';
    title:string = '';
    msg:string = ``;
}